export const getEditorOptions = placeholder => ({
  formats: [
    'bold',
    'bullet',
    'image',
    'outdent',
    'indent',
    'italic',
    'link',
    'list',
    'ordered',
    'underline',
  ],
  modules: {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline'],
        ['link', 'image'],
        [{ list: 'bullet' }, { list: 'ordered' }],
        [{ indent: '-1' }, { indent: '+1' }],
      ],
      handlers: {
        bold: function() {
          this.quill.format('bold', !this.quill.getFormat().bold);
        },
        italic: function() {
          this.quill.format('italic', !this.quill.getFormat().italic);
        },
        underline: function() {
          this.quill.format('underline', !this.quill.getFormat().underline);
        },
      },
    },
  },
  placeholder: placeholder,
});
